import React, {Component, Fragment, useCallback, useEffect, useState} from 'react';

import {Picker, List, Flex, Grid, Tabs, Icon, NoticeBar, Toast, Checkbox} from 'antd-mobile';
import PublicHeader from './../../components/header/index';
import {getVenueDetail, getSiteList, getVenueList, createOrder} from './store/actionCreators';
import {connect} from 'react-redux';
import _ from 'lodash';
import './index.scss';
import history from '../../utils/history';

const CheckboxItem = Checkbox.CheckboxItem;
const Item = List.Item;
const Brief = Item.Brief;

function ItemSelect(props) {
    const [cartItem, setCartItem] = useState([]);
    const [spaceInfos, setSpaceInfos] = useState([])
    const [spaceInfoTab, setSpaceInfoTab] = useState([])
    const [isForceUpdate, setIsForceUpdate] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0)
    const [product, setProduct] = useState([]);

    async function loadCartData() {
        var mulBusiness = [];
        var spaceInfoList = [];
        var venueId = props.events.location.state.id;
        const result = await props.events.getVenueDetail(venueId);
        const {spaceInfoDTOS = [{}]} = result.value;
        spaceInfoDTOS.map((item, index) => {
            var tSpaceDetails = [];
            var productDetail = {};
            productDetail.title = item.title;
            productDetail.key = item.key;
            productDetail.details = tSpaceDetails;
            const {spaceDetails = [{}]} = item;
            spaceDetails.map((item, index) => {
                let productItem = {};
                productItem.id = item.seq;
                productItem.seq = item.seq;
                productItem.Selected = false;
                productItem.key = item.key;
                productItem.name = item.name;
                productItem.label = item.dateLabel;
                productItem.price = item.price;
                productDetail.details.push(productItem);
            });
            spaceInfoList.push(productDetail)
        })
        setCartItem(mulBusiness);
        setSpaceInfos(spaceInfoList);
        setTotalPrice(0);
    }

    useEffect(() => {
        loadCartData();
    }, [isForceUpdate]);

    useEffect(() => {
        loadCartData();
    }, []);

    const handleCheckedItem = (tab, data, event) => {
        spaceInfos.map((item, index) => {
            item.details.map((detail, index) => {
                if (tab.key == detail.key && data.id == detail.id) {
                    if (event.target.checked) {
                        console.log("price", detail.price)
                        setTotalPrice((prevCartTotalPrice) => (
                            prevCartTotalPrice = prevCartTotalPrice += detail.price
                        ));
                        detail.Selected = true;
                    }
                    else {
                        setTotalPrice((prevCartTotalPrice) => (
                            prevCartTotalPrice = prevCartTotalPrice -= detail.price
                        ));
                        detail.Selected = false;
                    }
                }
            })
        })
        updateProducts(data)
    }

    function updateProducts(data) {
        let selectdProducts = [];
        spaceInfos.map((item, index) => {
            item.details.map((detail, index) => {
                if (detail.Selected) {
                    selectdProducts.push({
                        id: detail.seq,
                        Selected: false,
                        name: detail.name,
                        label: detail.dateLabel,
                        price: detail.price,
                        seq: detail.seq,
                    });
                }
            })
        })
        setProduct(selectdProducts);
    }


    function renderTabContent(tab) {
        return tab.details.map((item, index) => {
            return (
                <CheckboxItem key="disabled" multipleLine
                              onChange={(event) => {
                                  handleCheckedItem(tab, item, event)
                              }}>
                    <div>
                        {item.label}<span style={{color: "#E87908", float: "right"}}>¥{item.price / 100}</span>
                    </div>
                </CheckboxItem>
            );
        })
    }

    function HandleSubmitOrder() {
        Toast.loading('加载中...', 2, () => {
            Toast.hide();
        });

        let userInfo = Storage.Base.getInstance().get('_loginTk');
        if (userInfo === null) {
            history.push('./login');
            return;
        }
        let siteId = props.siteId;
        if (!siteId) {
            Toast.show("请选择场地！")
            return;
        }
        let price = totalPrice;

        if (price <= 0) {
            Toast.show("请选择时间段！")
            return;
        }
        let selectdProducts = [];
        spaceInfos.map((item, index) => {
            var skus = [];
            var productDetail = {};
            productDetail.userId = userInfo.id;
            productDetail.siteId = siteId;
            productDetail.date = item.title
            item.details.map((detail, index) => {
                if (detail.Selected) {
                    let productItem = {};
                    productItem.id = detail.id;
                    productItem.seq = detail.seq;
                    productItem.key = detail.key;
                    productItem.name = detail.name;
                    productItem.label = detail.label;
                    productItem.price = detail.price;
                    skus.push(productItem);
                }
            })
            productDetail.skus = skus;
            if (skus.length != 0) {
                selectdProducts.push(productDetail);
            }
        })
        if (selectdProducts.length != 1) {
            Toast.show("暂不支持跨天选择时间段！请重新选择。")
            return;
        }
        props.events.createOrder(selectdProducts[0]);
        Toast.hide();
    }

    return (
        <Flex>
            <Flex.item>
                <Tabs tabs={spaceInfos}
                      renderTabBar={props => <Tabs.DefaultTabBar {...props} page={3}/>}>
                    {renderTabContent}
                </Tabs>
            </Flex.item>
            <div className="art-order-detail__footer">
                <div>合计: <span>￥{totalPrice / 100}</span></div>
                <div onClick={HandleSubmitOrder}>
                    立即预订
                </div>
            </div>
        </Flex>
    )
}

const SpaceInfo = (props) => {
    var [siteList, setSiteList] = useState([])
    var [pickerValue, setPickerValue] = useState()
    const {getSiteList} = props;

    async function loadCartData() {
        var venueId = props.location.state.id;
        const result = await getSiteList(venueId);
        console.log("sites", result)
        setSiteList(result.value);
    }

    useEffect(() => {
        loadCartData();
    }, []);

    return (
        <Fragment>
            <PublicHeader title="场地预定"/>
            <NoticeBar mode="closable" icon={<Icon type="check-circle-o" size="xxs"/>}>
                必须为连续时间段,不能跨时间段预订!
            </NoticeBar>
            <Picker data={siteList}
                    cols={1}
                    onChange={v => setPickerValue(v)}
                    className="forss"
                    onOk={v => setPickerValue(v)}
                    value={pickerValue}>
                <List.Item arrow="horizontal"><span style={{color: 'red'}}>*</span>选择场地</List.Item>
            </Picker>
            <List.Item><span style={{color: 'red'}}>*</span>选择时间段</List.Item>

            <ItemSelect events={props} siteId={pickerValue}/>

        </Fragment>
    )
}

const mapDispatchToProps = (dispatch) => ({
    getVenueDetail: (id) => dispatch(getVenueDetail(id)),
    getSiteList: (id) => dispatch(getSiteList(id)),
    createOrder: (param) => dispatch(createOrder(param))
});

export default connect(null, mapDispatchToProps)(React.memo(SpaceInfo));
